import { Icon } from '@iconify/react';
import { useTranslation } from 'react-i18next';

/**
 * Microphone button that triggers voice recording mode.
 * Only shown in idle state — during recording, VoiceRecordingBar takes over.
 */
export function VoiceInputButton({ error, disabled, onClick }) {
  const { t } = useTranslation();
  return (
    <div className="relative">
      <button
        onClick={onClick}
        disabled={disabled}
        className="flex items-center justify-center size-10 m-1 rounded-lg text-[var(--color-text-muted)] hover:bg-[var(--color-bg-muted)] hover:text-[var(--color-text-secondary)] disabled:text-[var(--color-text-muted)] disabled:hover:bg-transparent disabled:cursor-not-allowed cursor-pointer transition-colors"
        aria-label={t('ai.voice.startVoiceInput')}
        title={error || t('ai.voice.voiceInput')}
      >
        <Icon icon="mdi:microphone" className="size-5" />
      </button>
      {error && (
        <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-2 py-1 text-xs text-red-600 bg-red-50 border border-red-200 rounded whitespace-nowrap">
          {error}
        </div>
      )}
    </div>
  );
}
